import { fileDownload } from "@/utils";
import axios from "@/user/axios.js";

const moduleCampaignReport = {
  namespaced: true,
  state: {
    requestingStatus: {
      expectedLandingByPortfolio: false,
      monthly: false,
      summary: false,
      summaryByPortfolio: false,
      costByPortfolioName: false,
      costByCampaign: false,
      costByAdGroupName: false,
    },
    reportData: {
      expectedLandingByPortfolio: [],
      monthly: [],
      summary: [],
      summaryByPortfolio: [],
      costByPortfolioName: [],
      costByCampaign: [],
      costByAdGroupName: [],
    },
  },

  mutations: {
    SET_REQUESTING_STATUS(state, data) {
      state.requestingStatus = {
        ...state.requestingStatus,
        ...data,
      };
    },
    SET_REPORT_DATA(state, data) {
      state.reportData = {
        ...state.reportData,
        ...data,
      };
    },
  },
  actions: {
    fetchReport(context, payload) {
      return new Promise(async (resolve, reject) => {
        context.commit("SET_REQUESTING_STATUS", {
          [payload.action]: true,
        });
        const sellerId = context.rootState.account.activeAccount.sellerId;
        try {
          const res = await axios.get(`/api/campaign-reports/${sellerId}`, {
            params: payload,
          });
          context.commit("SET_REQUESTING_STATUS", {
            [payload.action]: false,
          });
          if (res.data.success) {
            context.commit("SET_REPORT_DATA", {
              [payload.action]: res.data.data,
            });
          }
          resolve(res);
        } catch (err) {
          context.commit("SET_REQUESTING_STATUS", {
            [payload.action]: false,
          });
          reject(err);
        }
      });
    },
    downloadCSV(context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId;
        try {
          const res = await axios.get(
            `/api/campaign-reports/download/${sellerId}`,
            {
              responseType: "blob",
              params: payload,
            }
          );
          const fileName = decodeURIComponent(
            res.headers["content-disposition"].split("filename*=UTF-8''")[1]
          );
          fileDownload(res.data, fileName);
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
  },
};

export default moduleCampaignReport;
